import { AssignmentDistrictMaintenanceGetResponse } from '../pages/assignment-district-maintenance/interfaces/assignment-district-maintenance-get-response';
import { AssignmentDistrictMaintenanceGetRequest } from '../pages/assignment-district-maintenance/interfaces/assignment-district-maintenance-get-request';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AssignmentDistrictMaintenanceSaveRequest } from '../pages/assignment-district-maintenance/interfaces/assignment-district-maintenance-save-request';

@Injectable({
  providedIn: 'root'
})
export class AssignmentDistrictService {

  private baseUrl: string = `${environment.logisticsApiUrl}/assignmentDistrict/maintenance`
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  getAssignmentDistrict(request: AssignmentDistrictMaintenanceGetRequest): Observable<AssignmentDistrictMaintenanceGetResponse> {
    return this.http.post<AssignmentDistrictMaintenanceGetResponse>(this.baseUrl, request, this.httpOptions);
  }

  saveAssignmentDistrictMaintenanceChanges(request: AssignmentDistrictMaintenanceSaveRequest): Observable<void> {
    return this.http.put<void>(this.baseUrl, request, this.httpOptions);
  }

  async findByFacilityAndCitySeqIn(facility: string, citySeqNos: any[]): Promise<any> {
    const url = `${environment.logisticsApiUrl}/assignmentDistrict/findByFacilityAndCitySeqIn/${facility}`;
    const params = new HttpParams({ fromObject: { citySeqNos: citySeqNos.map(String) } });
    return this.http.get(url, { params }).toPromise();
  }
}
